import RequestMaster from '../RequestMaster'

export default class RequestFacturacionColegio extends RequestMaster {

    constructor() {
        super()
        this.URL_BASE = this.URL_BASE + '/colegio/facturacion'
    }
}
